import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-forgot-password-afterlogin',
  templateUrl: './forgot-password-afterlogin.component.html',
  styleUrls: ['./forgot-password-afterlogin.component.scss']
})
export class ForgotPasswordAfterloginComponent implements OnInit {
  regEmail:any;
  showregemailErrorMsg:any;
  constructor(private router: Router) { }

  ngOnInit(): void {
  }
  regemailErrorMsg() 
  {
    if (!this.regEmail) { this.showregemailErrorMsg = true; } else { this.showregemailErrorMsg = false }
  }


  forgotPassword() 
  {
      
      var flag = true;
      if (!this.regEmail || this.regEmail == "") { this.showregemailErrorMsg = true; flag = false }
   
        if (flag == true) 
        {
          this.router.navigate(['/create-new-password']);

        }
   }
}
